import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { SkillChangeViaSchema } from './admin-document-analysis-skills.events';

/**
 * Published on every edit of a system-family managed skill (IMM-469.2) — the
 * document-analysis fallback is the first. A sibling of
 * `admin.documentAnalysisSkillChanged` rather than a reuse of it: a system skill
 * has no `category`, so it carries the generic `(kind, key)` identity instead.
 * Rides the outbox to the future IMM-67 admin audit surface; the queryable
 * before/after diff lives in the `immo_admin.skill_changes` journal.
 */
export const SystemSkillChangedPayloadSchema = z.object({
  kind: z.string(),
  key: z.string(),
  action: z.enum(['created', 'prompt_edited', 'activated', 'deactivated']),
  actor: ActorSchema,
  via: SkillChangeViaSchema.nullable().optional(),
  occurredAt: z.iso.datetime(),
});

export type SystemSkillChangedPayload = z.infer<typeof SystemSkillChangedPayloadSchema>;
